"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Captcha = _ref => {
  let {
    captchaKey,
    captchaRef,
    onChange,
    captchaLanguage,
    error
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-padding-03-bottom sia-padding-03-right"
  }, /*#__PURE__*/_react.default.createElement(_reactGoogleRecaptcha.default, {
    ref: captchaRef,
    sitekey: captchaKey,
    onChange: onChange,
    hl: captchaLanguage
  }), error && /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-padding-02-bottom sia-text-07"
  }, error));
};
Captcha.propTypes = {
  captchaKey: _propTypes.default.string.isRequired,
  captchaRef: _propTypes.default.object.isRequired,
  captchaLanguage: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired,
  error: _propTypes.default.string
};
var _default = exports.default = Captcha;